import { Capacitor } from "@capacitor/core";
import React, { useEffect, useState } from "react";
import OtpInput from "../reusableComponents/OtpInput";
import { Link, useLocation } from "react-router-dom";
import showNotification from "../../services/redux/NotifcationService";
import { useDispatch } from "react-redux";
import {
  CreateStaffUser,
  customerLoginApi,
  customerVerifyOtpApi,
  login,
} from "../../services/redux/ApiActions";
import { setCustomerAuthenticate } from "../../services/redux/CustomerAuthentication";
import { setCustomerData } from "../../services/redux/CustomerDataReducer";
import LogoDiv from "../Common/LogoDiv";
import { setSuccessPage } from "../../services/redux/SuccessReducer";
import ORComponent from "../Common/ORComponent";
import ResendOTPComponent from "../Common/ResendOTPComponent";
import PDF from "../../Terms-and-Conditions-V2P.pdf";
import RecaptchaComponent from "../Common/RecaptchaComponent";
import logo from "../../img/BBPS_Horizontal.png";
import Footer from "../Common/Footer";

const RegLogin = () => {
  const [otp, setOtp] = useState("");
  const [recaptcha, setRecaptcha] = useState("");
  const [email, setEmail] = useState("");
  const [stars, setStars] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  let showTermsAndConditions =
    location?.state.data.smsNotification === true &&
    location?.state.data.termAccepted === true &&
    location?.state.data.whatsAppNotification === true &&
    location?.state.data.bharatConnect === true
      ? false
      : true;
  let showBharatConnect =
    location?.state.data.programId === 32 ||
    location?.state.data.programId === 33
      ? location?.state.data.bharatConnect === true
        ? false
        : true
      : false;
  const [resendCounter, setResendCounter] = useState(30);

  // const email = location?.state.email;
  const [termsAndConditions, setTermsAndConditions] = useState(
    location?.state.data.termAccepted === true ? true : false,
  );
  const [bharatConsentCheck, setBharatConsentCheck] = useState(
    location?.state.data.bharatConnect === true ? true : false,
  );
  const [notificationsCheck, setNotificationsCheck] = useState(
    location?.state.data.smsNotification === true &&
      location?.state.data.whatsAppNotification === true
      ? true
      : false,
  );
  const [enableResendOTP, setEnableResendOTP] = useState(false);

  function onChangeCaptcha(value) {
    // console.log("Captcha value:", value);
    setRecaptcha(value);
  }

  useEffect(() => {
    // const lastDigits = location?.state.data.email.slice(-4); // Show only the last 4 digits for privacy
    // const fetchedStars = '*****'; // Replace this with the actual stars
    // Check if the email is valid (contains '@')
    if (!location?.state.data.email.includes("@")) {
      return location?.state.data.email; // Return the original input if it's not a valid email
    }

    // Split the email into local part and domain
    const [localPart, domain] = location?.state.data.email.split("@");

    // If the local part is too short, return the original email
    if (localPart.length <= 2) {
      return location?.state.data.email;
    }

    // Mask the local part (keep the first and last character visible)
    const maskedLocalPart =
      localPart[0] +
      "*".repeat(localPart.length - 2) +
      localPart[localPart.length - 1];
    setEmail(`${maskedLocalPart}@${domain}`);
    // setStars(fetchedStars);
  }, [email]);

  const handleSubmit = async () => {
    const data = {
      customerId: location?.state.data.customerID,
      otp: otp,
      createdBy: "",
      createdIp: "",
      createdUserAgent: "",
      recaptchaValue: recaptcha,
      termAccepted: termsAndConditions === true ? true : false,
      smsNotification: notificationsCheck === true ? true : false,
      whatsAppNotification: notificationsCheck === true ? true : false,
      bharatConnect: bharatConsentCheck === true ? true : false,
    };
    if (otp === "") {
      showNotification("OTP is required", "error");
    } else if (otp.length !== 6) {
      showNotification("OTP must be of 6 digits", "error");
    } else if (termsAndConditions === false) {
      showNotification("Please Accept Terms And Conditions", "error");
    } else if (notificationsCheck === false) {
      showNotification("Please allow SMS and Whatsapp notifications", "error");
    } else if (
      (location?.state.data.programId === 32 ||
        location?.state.data.programId === 33) &&
      bharatConsentCheck === false
    ) {
      showNotification("Please agree to join Bharat Connect.", "error");
    } else if (recaptcha === undefined) {
      showNotification("Please enter Recaptcha", "error");
    } else {
      const response = await dispatch(customerVerifyOtpApi(data));
      if (response?.result.token_chr) {
        dispatch(setCustomerAuthenticate(true));
        dispatch(setSuccessPage(false));
        dispatch(setCustomerData(response.result));
      }
    }
  };

  const Resend = async () => {
    const data = {
      mailToken: location?.state.token,
      createdIp: "",
      createdUserAgent: "",
    };
    try {
      const response = await dispatch(customerLoginApi(data));
      if (response.statusCode === 200) {
        showNotification("OTP Resent Successfully", "success");
        setResendCounter(30);
        setEnableResendOTP(false);
      }
    } catch (error) {
      showNotification(error, "error");
    }
  };

  const handleTermsAndConditions = () => {
    setTermsAndConditions(!termsAndConditions);
  };

  const handleNotificationCheck = () => {
    setNotificationsCheck(!notificationsCheck);
  };
  const handleBharatConsentCheck = () => {
    setBharatConsentCheck(!bharatConsentCheck);
  };
  const handleChange = (e) => {
    const value = e.target.value.slice(0, 6);
    const sanitizedValue = value.replace(/\D/g, "");
    setOtp(sanitizedValue);
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setEnableResendOTP(true)
  //   }, 30000);
  // }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (resendCounter > 0) {
        setResendCounter((prevCounter) => prevCounter - 1);
      } else {
        setEnableResendOTP(true);
      }
    }, 1000);

    // Clear the interval when component unmounts
    return () => clearInterval(interval);
  }, [resendCounter]);

  return (
    <body className="mailSentBody">
      <LogoDiv className="logoBG">
        <div className="rightElement">
          <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
            <div
              style={{
                backgroundColor: `${
                  Capacitor.isNative === true ? "transparent" : "white"
                }`,
                padding: `${Capacitor.isNative === true ? "5px" : "20px"}`,
              }}
              className="rounded-lg shadow-xl  mt-5 sm:mx-auto sm:w-full md:max-w-sm lg:max-w-lg"
            >
              <div className="space-y-6">
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    marginTop: "-5px",
                  }}
                >
                  <img src={logo} width={"100px"} height={"100px"} />
                </div> */}
                <div>
                  <h2 className="pb-2 mt-4 text-center text-lg font-semibold leading-9 tracking-tight text-gray-900 letter-spacing">
                    WELCOME! {location?.state.data.name}
                  </h2>
                  <div className="pb-3">
                    <p className="pb-2 text-sm text-center text-gray-500">
                      Please enter the OTP to complete your profile
                    </p>
                  </div>
                  <div style={{ backgroundColor: "#dff0d8" }} className="py-3">
                    <p className="pb-2 text-sm text-center text-gray-500">
                      OTP is sent on {/* (+91) {phone && `${stars}${phone}`} */}
                      {email}
                    </p>
                  </div>
                  {/* <label htmlFor="email" className="block text-md font-medium leading-6 text-gray-900">One Time Password </label> */}
                  <div className="mt-5">
                    <OtpInput
                      value={otp || ""}
                      onChange={handleChange}
                      inputStyles={{
                        paddingLeft: "10px",
                        padding: "15px 10px",
                      }}
                    />
                  </div>
                </div>
                <RecaptchaComponent onChangeCaptcha={onChangeCaptcha} />
                {showTermsAndConditions === true ? (
                  <>
                    <div className="grid mt-6 grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-1 lg:col-span-1">
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="mt-1 form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                          checked={termsAndConditions}
                          onChange={handleTermsAndConditions}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-11 lg:col-span-11">
                        <label
                          htmlFor="checkboxOption2"
                          className="text-gray-500 text-sm font-semibold"
                        >
                          I hereby accept the{" "}
                          <a
                            target="_blank"
                            href={PDF}
                            className="text-blue-700 hover:cursor-pointer"
                          >
                            Terms & Conditions
                          </a>{" "}
                          and{" "}
                          <a
                            target="_blank"
                            href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
                            className="text-blue-700 hover:cursor-pointer"
                          >
                            Privacy Policy
                          </a>{" "}
                          of using the Vendor To Pay platform.
                        </label>
                      </div>
                      <div className="col-span-12 md:col-span-1 lg:col-span-1">
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="mt-1 form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                          checked={notificationsCheck}
                          onChange={handleNotificationCheck}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-11 lg:col-span-11">
                        <label
                          htmlFor="checkboxOption2"
                          className="text-gray-500 text-sm font-semibold"
                        >
                          {/* I allow Vendor To Pay to send SMS and Whatsapp notifications. */}
                          I allow “Vay Network Services Pvt Ltd” to send SMS and
                          Whatsapp notifications.
                        </label>
                      </div>
                      {showBharatConnect && (
                        <>
                          <div className="col-span-12 md:col-span-1 lg:col-span-1">
                            <input
                              type="checkbox"
                              id="checkboxOption2"
                              name="gstin"
                              className="mt-1 form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                              checked={bharatConsentCheck}
                              onChange={handleBharatConsentCheck}
                            />
                          </div>
                          <div className="col-span-12 md:col-span-11 lg:col-span-11">
                            <label
                              htmlFor="checkboxOption2"
                              className="text-gray-500 text-sm font-semibold"
                            >
                              I agree to join Bharat Connect for business
                              ecosystem though Vay Network Services Private
                              Limited as Operating Unit.
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div>
                  <center>
                    <button
                      onClick={handleSubmit}
                      className="flex w-10/12 justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                      style={{ backgroundColor: "#2E61A2" }}
                      // disabled={(termsAndConditions === true && notificationsCheck === true) ? false : true}
                    >
                      Proceed
                    </button>
                  </center>
                </div>
              </div>
              {/* {(termsAndConditions === true && notificationsCheck === true) ? ( */}
              <ORComponent />
              <div className="flex justify-center">
                <button
                  style={{ color: enableResendOTP === true ? "" : "#ccc" }}
                  onClick={Resend}
                  disabled={enableResendOTP === true ? false : true}
                  className=" bg-transparent "
                >
                  <ResendOTPComponent />
                </button>
              </div>
              {/* ) : (ww
                <p className="border-t border-gray-200 pt-4 mt-6 text-center text-sm text-gray-500">
                  <ion-icon style={{ fontSize: '25px', marginBottom: '-7.2px', paddingRight: '10px' }} name="sync"></ion-icon>
                  Resend OTP
                </p>
              )} */}
            </div>
            <Footer />
          </div>
        </div>
      </LogoDiv>
    </body>
  );
};

export default RegLogin;
